import {Injectable} from '@angular/core';
import {Subscription} from '../../../../models/acquista-servizi-models/subscription';
import {Service} from '../../../../models/acquista-servizi-models/service';
import {ShopPortfolio} from '../../../../models/acquista-servizi-models/shop-portfolio';
import {Products} from '../../../../models/Products';


@Injectable({
  providedIn: 'root'
})
export class ProductsStore {

  atLeastOneSubscriptionExists: boolean;
  atLeastOneServiceExists: boolean;
  atLeastOnePortfolioExists: boolean;

  subscriptions: Subscription[];
  services: Service[];
  portfolios: ShopPortfolio[];
  allProductsList: Products[];
  autocompleteValues: string[];
  product: Products;

  constructor() {
    this.subscriptions = [];
    this.services = [];
    this.portfolios = [];
    this.allProductsList = [];
  }

  loadSubscriptions(subscriptions: Subscription[]) {
    this.subscriptions = subscriptions;
  }

  loadServices(services: Service[]) {
    this.services = services;
  }

  loadPortfolios(portfolios: ShopPortfolio[]) {
    this.portfolios = portfolios;
  }

  loadAllProducts(products: Products[]) {
    this.allProductsList = products;
  }

  checkSubscriptionsNotEmpty() {
    this.atLeastOneSubscriptionExists = this.subscriptions.length > 0;
  }

  checkServicesNotEmpty() {
    this.atLeastOneServiceExists = this.services.length > 0;
  }
  checkPortfoliosNotEmpty() {
    this.atLeastOnePortfolioExists = this.portfolios.length > 0;
  }

}
